import { API, APICall } from '../Api'

export default {
  name: 'Programs',

  methods: {
    async get (id) {
      const Request = {
        Type    : APICall.Program.Get.Type,
        Endpoint: APICall.Program.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async save (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Program.Save.Type,
        Endpoint: APICall.Program.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.Program.List.Type,
        Endpoint: APICall.Program.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async programFilters () {
      const Request = {
        Type    : APICall.Program.Filters.Type,
        Endpoint: APICall.Program.Filters.Endpoint,
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allGroups (data) {
      const Request = {
        Type    : APICall.Program.Group.List.Type,
        Endpoint: APICall.Program.Group.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allTemplates (data) {
      const Request = {
        Type    : APICall.Program.Template.List.Type,
        Endpoint: APICall.Program.Template.List.Endpoint,
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async defaultCars (data) {
      const Request = {
        Type    : APICall.Program.Cars.List.Type,
        Endpoint: APICall.Program.Cars.List.Endpoint,
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async defaultTyres (data) {
      const Request = {
        Type    : APICall.Program.Tyres.List.Type,
        Endpoint: APICall.Program.Tyres.List.Endpoint,
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
